var map = {
	"./Disabled.svg": 2294,
	"./HasWarnings.svg": 2295,
	"./Healthy.svg": 2296,
	"./Unavailable.svg": 2297,
	"./Unhealthy.svg": 2298,
	"./Unknown.svg": 2299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1124;